import React from "react";
import { FormControl, Select, MenuItem, InputLabel, Box } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

interface DropdownListProps {
  data: { id: number; name: string }[];
  value: string | null;
  setValue: (newValue: string) => void;
  caption?: string;
  label?: string;
  hideLabel?: boolean;
}

const DropdownList = ({
  data,
  value,
  setValue,
  caption = "Select...",
  label,
  hideLabel,
}: DropdownListProps) => {
  return (
    <MDBox display="flex" flexDirection="column" width="100%">
      {!hideLabel && label && (
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="medium"
          mb={0.5}
        >
          {label}
        </MDTypography>
      )}

      <FormControl fullWidth size="medium">
        <Select
          value={value || ""}
          displayEmpty
          onChange={(e) => setValue(e.target.value)}
          sx={{
            borderRadius: 1,
            "& .MuiSelect-select": { padding: "10px" },
          }}
        >
          {/* Placeholder */}
          {value === "" && (
            <MenuItem disabled value="">
              <span style={{ opacity: 0.5 }}>{caption}</span>
            </MenuItem>
          )}

          {data.map((item) => (
            <MenuItem key={item.id} value={item.name}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </MDBox>
  );
};

export default DropdownList;
